/**
 * if we find these, assume they're abbreviations, not the end of a sentence,
 * so it doesn't include abbreviations like "i.", "in.", or "mass." which are legal words,
 * or "etc." which often ends a sentence
 */
export const en_US_Abbrevs: Record<string, string> = {
  "a.": "/ˈeɪ/",
  "a.d.": "/ˌeɪˈdi/",
  "a.m.": "/ˌeɪˈɛm/",
  "a.p.i.": "/ˈeɪˈpiˈaɪ/",
  "apr.": "/ˈeɪpɹəɫ/",
  "ariz.": "/ˌɛɹɪˈzoʊnə/",
  "aug.": "/ˈɑɡəst/",
  "b.": "/ˈbi/",
  "b.c.": "/ˌbiˈsi/",
  "c.": "/ˈsi/",
  "c.e.o.": "/ˌsiˌʔiˈoʊ/",
  "c.f.o.": "/ˌsiˌɛfˈoʊ/",
  "c.o.d.": "/ˈsiˈoʊˈdi/",
  "calif.": "/ˌkæɫəˈfɔɹnjə/",
  "co.": "/ˈkəmpəni/",
  "conn.": "/kəˈnɛtəkət/",
  "corp.": "/ˈkɔɹp/",
  "cr.": "/ˈkɹɛsənt/",
  "d.": "/ˈdi/",
  "d.c.": "/ˌdiˈsi/",
  "dec.": "/dɪˈsɛmbɝ/",
  "dr.": "/ˈdɑktɝ/",
  "e.": "/ˈi/",
  "e.g.": "/ˌiˈdʒi/",
  "est.": "/ɪˈstæbɫɪʃt/",
  "f.": "/ˈɛf/",
  "feb.": "/ˈfɛbjəˌwɛɹi/",
  "ft.": "/ˈfʊt/",
  "g.": "/ˈdʒi/",
  "gov.": "/ˈɡəvɝnɝ/",
  "h.": "/ˈeɪtʃ/",
  "inc.": "/ˈɪŋk/",
  "j.": "/ˈdʒeɪ/",
  "jan.": "/ˈdʒænjuˌɛɹi/",
  "jr.": "/ˈdʒunjɝ/",
  "jul.": "/ˌdʒuˈɫaɪ/",
  "jun.": "/ˈdʒun/",
  "k.": "/ˈkeɪ/",
  "l.": "/ˈɛɫ/",
  "lt.": "/ɫuˈtɛnənt/",
  "ltd.": "/ˈɫɪmɪtɪd/",
  "m.": "/ˈɛm/",
  "m.d.": "/ˌɛmˈdi/",
  "messrs.": "/mɪˈsuɹz/",
  "mich.": "/ˈmɪʃɪɡən/",
  "mr.": "/ˈmɪstɝ/",
  "mrs.": "/ˈmɪsɪz/",
  "ms.": "/ˈmɪz/",
  "mssrs.": "/ˈmɛsɝz/",
  "n.": "/ˈɛn/",
  "n.j.": "/ˌnuˈdʒɝzi/",
  "nov.": "/noʊˈvɛmbɝ/",
  "o.": "/ˈoʊ/",
  "oct.": "/ɑkˈtoʊbɝ/",
  "p.": "/ˈpi/",
  "p.m.": "/ˈpiˈɛm/",
  "q.": "/ˈkju/",
  "r.": "/ˈɑɹ/",
  "s.": "/ˈɛs/",
  "sen.": "/ˈsɛnətɝ/",
  "sep.": "/sɛpˈtɛmbɝ/",
  "sgt.": "/ˈsɑɹdʒənt/",
  "sr.": "/ˈsinjɝ/",
  "st.": "/ˈstɹit/",
  "t.": "/ˈti/",
  "u.": "/ˈju/",
  "u.k.": "/ˌjuˈkeɪ/",
  "u.n.": "/ˌjuˈɛn/",
  "u.s.": "/ˌjuˈɛs/",
  "u.s.a.": "/ˌjuˌɛˈseɪ/",
  "u.s.c.": "/ˌjuˌɛˈsi/",
  "u.w.": "/ˌjuˈdəb/",
  "v.": "/ˈvi/",
  "v.a.": "/ˌviˈeɪ/",
  "vs.": "/ˈvɝsəz/",
  "w.": "/ˈdəbəɫju/",
  "wyo.": "/ˌwaɪˈoʊmɪŋ/",
  "x.": "/ˈɛks/",
  "y.": "/ˈwaɪ/",
  "z.": "/ˈzi/",
}
